import gql from 'graphql-tag';

export const bulkUpdateInvoicesToPaidMutation = gql(/* GraphQL */ `
  mutation bulkUpdateInvoicesToPaid(
    $bulkUpdateInvoicesToPaidRequest: BulkUpdateInvoicesToPaidRequest!
  ) {
    bulkUpdateInvoicesToPaid(
      bulkUpdateInvoicesToPaidRequest: $bulkUpdateInvoicesToPaidRequest
    ) {
      successfulInvoiceIds
      failedInvoices {
        invoiceId
        errorMessage
      }
    }
  }
`);

